"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _ActionTypes = require("./actionTypes");
const _generatePreviewActionTypes = require("../files/generatePreview/actionTypes");
const statusLens = monocle.Lens.fromProp('status');
const errorLens = monocle.Lens.fromProp('error');
const listLens = monocle.Lens.fromProp('list');
const sortByOptions = monocle.Lens.fromProp('sortByOptions');
const sortByOptionsFiltersHelper = monocle.Lens.fromProp('filters');
const sortByOptionsFilter = sortByOptions.compose(sortByOptionsFiltersHelper);
const selectedLens = monocle.Lens.fromProp('selected');
const deleteStatusLens = monocle.Lens.fromProp('deleteStatus');
const deleteErrorLens = monocle.Lens.fromProp('deleteError');
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const GeneratePreviewActionTypes = _generatePreviewActionTypes.default(`preview-${namespace}`);
    const initialState = {
        status: 'STANDBY',
        error: undefined,
        selected: [],
        list: [],
        sortByOptions: {
            filters: undefined,
            limit: Infinity,
            offset: 0,
            order: 'desc',
            sortBy: 'version'
        },
        deleteStatus: 'STANDBY',
        deleteError: undefined
    };
    const methods = {};
    methods[ActionTypes.FETCH_REQUEST] = (state, action) => fp.function.compose(statusLens.set('FETCHING'), errorLens.set(undefined))(state);
    methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), listLens.set(action.payload))(state);
    methods[ActionTypes.FETCH_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
    methods[GeneratePreviewActionTypes.GENERATE_PREVIEW_REQUEST] = (state, action) => {
        if (state.status === 'FETCHED') {
            const list = state.list.map((rev, i) => {
                if (rev.uuid === action.payload) {
                    rev.preview = { uuid: '', status: 'PROCESSING' };
                }
                return rev;
            });
            return listLens.set(list)(state);
        }
        return state;
    };
    methods[GeneratePreviewActionTypes.GENERATE_PREVIEW_FAILURE] = (state, action) => {
        if (state.status === 'FETCHED') {
            const list = state.list.map((rev, i) => {
                if (rev.uuid === action.revisionUuid) {
                    rev.preview = { uuid: '', status: 'FAILED' };
                }
                return rev;
            });
            return listLens.set(list)(state);
        }
        return state;
    };
    methods[GeneratePreviewActionTypes.GENERATE_PREVIEW_SUCCESS] = (state, action) => {
        if (state.status === 'FETCHED') {
            const list = state.list.map((rev, i) => {
                if (rev.uuid === action.data.revisionUuid) {
                    rev.preview = { uuid: action.data.uuid, status: action.data.status };
                }
                return rev;
            });
            return listLens.set(list)(state);
        }
        return state;
    };
    methods[ActionTypes.SET_COLUMN_FILTER_STRING] = (state, action) => {
        const filters = state.sortByOptions.filters
            ? Object.assign({}, state.sortByOptions.filters) : {};
        if (action.payload.columnValue === null) {
            delete filters[action.payload.columnId];
        }
        else {
            filters[action.payload.columnId] = action.payload.columnValue;
        }
        return sortByOptionsFilter.set(filters)(state);
    };
    methods[ActionTypes.SET_ORDER] = (state, action) => sortByOptions.modify((opts) => (Object.assign(Object.assign({}, opts), { order: action.payload.order, sortBy: action.payload.orderBy })))(state);
    methods[ActionTypes.TOGGLE_SELECT] = (state, action) => selectedLens.modify((x) => {
        if (action.payload.status) {
            return action.payload.items.reduce((acc, item) => {
                if (acc.findIndex((x) => x.id === item.id) === -1) {
                    acc.push(item);
                }
                return acc;
            }, [...x]);
        }
        else {
            return action.payload.items.reduce((acc, item) => {
                return acc.filter((z) => z.id !== item.id);
            }, x);
        }
    })(state);
    methods[ActionTypes.DELETE_LATEST_REVISION_REQUEST] = (state, action) => fp.function.compose(deleteStatusLens.set('SAVING'), deleteErrorLens.set(undefined))(state);
    methods[ActionTypes.DELETE_LATEST_REVISION_SUCCESS] = (state, action) => deleteStatusLens.set('SAVED')(state);
    methods[ActionTypes.DELETE_LATEST_REVISION_FAILED] = (state, action) => fp.function.compose(deleteStatusLens.set('FAILED'), deleteErrorLens.set(action.payload))(state);
    methods[ActionTypes.CLEAR] = () => (Object.assign({}, initialState));
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods, ActionTypes };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map